/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../../constants'

import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isViewDetailShown: false,
			isEdit: false,
			selectedResolution: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_type } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedResolution
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Barangay Management</a></li>
									<li className="breadcrumb-item active">Barangay Resolutions</li>
								</ol>
							</div>
							<h4 className="page-title">Barangay Resolutions</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row>
									<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
										this.setState({ isAddFormShown: true, isEdit: false, selectedResolution: null })
									}} style={{ float: 'right' }}>Add New</button>
									<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
										this.setState({ searchText: e.target.value })
									}}/>
								</Row>
								<br />
								<Row>
									<Query 
										query={BARANGAY_RESOLUTIONS} 
										variables={{ searchFilter: filters, barangay_uid }}
										fetchPolicy='network-only'
									>
										{({ loading, error, data }) => {
											if (error) return <Empty/>

											let allResolutions = _.has(data,'allResolutions') ? data.allResolutions.data : []
											allResolutions = allResolutions.map((allResolution, key) => Object.assign({}, allResolution, { key }))
											let _pagination = _.has(data, 'allResolutions') ? data.allResolutions.pagination : {}
											_pagination = Object.assign({}, _pagination, {
												pageSizeOptions: ['10', '25', '50'],
												showSizeChanger: true,
												total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
												showTotal: (total) => `Total ${total} items`
											})

											const columns = [
												{
													title: '#',
													dataIndex: 'id',
													key: 'id',
													width: 70
												}, {
													title: 'Title',
													dataIndex: 'title',
													key: 'title',
												//width: 300
												}, {
													title: 'Date Created',
													key: 'created_at',
													render: (record) => (
														<span>{moment(record.created_at).format('lll')}</span>
													)
												}, {
													title: 'Action',
													key: 'action',
													render: (record) => {
														return (
															<React.Fragment>
																<a 
																	style={{ marginRight: 10 }}
																	href="#" 
																	onClick={() => {
																		const certificate_url = `${process.env.REACT_APP_BACKEND_API}${record.file_url}`
																		window.open(certificate_url, '_blank')
																	}}
																>View</a>
																{
																	isAdmin &&
																	<a href="#" style={{ marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedResolution: record })}>Edit</a>
																}
																{
																	isAdmin &&
																	<Popconfirm
																		title="Are you sure delete this resolution?"
																		onConfirm={() => {
																			const { deleteResolution } = this.props
																			deleteResolution({ resolution_uid: record.uid })
																				.then((response) => {
																					message.success('Resolution successfully deleted.')

																					//create audit trail
																					const auditParams = {
																						module_name: 'Resolutions',
																						action: 'Delete',
																						message: `Deleted resolution ${record.title}`
																					}
																					AuthStore.saveAuditTrail(auditParams)
																				}).catch(err => {
																					console.log('error deleting resolution', err)
																					message.error(err.message.replace('GraphQL error:', ''))
																				})
																		}}
																		// onCancel={cancel}
																		okText="Yes"
																		cancelText="No"
																	>
																		<a href="javascript:void(0)" >Delete</a>
																	</Popconfirm>
																}
															</React.Fragment>
														)
													}
												}]
											return (
												<Table 
													loading={loading}
													columns={columns} 
													dataSource={allResolutions} 
													bordered
													onChange={this.handleOnChange}
													pagination={_pagination}
													scroll={{ x: 1020 }}
												/>
											)
										}}
									</Query>
								</Row>
							</div>
						</div>
					</div>
				</div>
				{
					isAddFormShown &&
					<AddForm
						isEdit={isEdit}
						selectedResolution={selectedResolution}
						visible={isAddFormShown}
						onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedResolution: null })}
					/>
				}
			</React.Fragment>
		)
	}
}

const BARANGAY_RESOLUTIONS = gql`
    query allResolutions($barangay_uid: String, $searchFilter: SearchParams) {
		allResolutions(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_RESOLUTION = gql`
    mutation deleteResolution($input: JSON) {
		deleteResolution(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_RESOLUTION, {
		props({ mutate }) {
			return {
				deleteResolution(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allResolutions']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
